export default "__VITE_ASSET__DsY9UbBF__"